import React from "react";
import Image from "next/image";
import isEmpty from "lodash/isEmpty";
import styled from "styled-components";
import ScreenReader from "components/ScreenReader";
import UIButton from "components/Button";
// import BackIcon from "./back-icon.svg";
import backImage from "./back-icon.png";

const Wrapper = styled.footer`
  flex: 0 1 auto;
  padding: 1.5rem;
  width: 100%;
  max-width: 120rem;
  margin: 0 auto;
`;

const Row = styled.div`
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  margin-bottom: 1.5rem;
  min-height: 5.2rem;

  @media (min-width: 480px) {
    min-height: 6.2rem;
  }
`;

const BackButton = styled.button`
  flex: 0 1 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 5rem;
  height: 5rem;

  svg {
    display: block;
    width: 24px;
    height: 24px;
  }
`;

const BackButtonImage = styled.div`
  display: block;
  width: 24px;
  height: 24px;
`;

const Button = styled(UIButton)`
  &[disabled] {
    background-color: #ccc;
    cursor: not-allowed;
  }
`;

const ButtonOutline = styled.button`
  display: inline-block;
  padding: 1.5rem;
  min-width: 18rem;
  text-align: center;
  font-weight: bold;
  border-radius: 0.5rem;
  color: #363334;
  background-color: #fff;
  border: 1px solid #ccc;
  transition: background-color 0.2s ease-out;
  margin-bottom: ${(props) => (props.hasAnswer ? "2rem" : 0)};

  @media (hover: hover) {
    &:hover {
      background-color: #e8e8e8;
    }
  }

  @media (min-width: 480px) {
    padding: 2rem;
    font-size: 1.8rem;
    margin-right: ${(props) => (props.hasAnswer ? "2rem" : 0)};
    margin-bottom: 0;
  }
`;

const ButtonGroup = styled.div`
  margin-left: auto;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;

  @media (min-width: 480px) {
    flex-direction: row;
  }
`;

const Disclaimer = styled.small`
  display: block;
  width: 100%;
  text-align: center;
  color: #848484;
  font-size: ${(props) => (props.long ? "1.2rem" : "1.5rem")};
`;

const Footer = (props) => {
  // Decide whether to show Next/Submit Button
  const outputButton = () => {
    const buttons = [];

    // Does the current question have an answer...
    const hasAnswer = !isEmpty(props.answer);

    // Is this a single choice question...
    const isSingleChoice =
      !props.multiChoice && !!props.answer.find((a) => a.type === "text");

    // Is the given answer invalid...
    const isInvalid = props.answer.find(
      (a) => a.hasOwnProperty("isValid") && !a.isValid
    );

    // No Budget option...
    if (props.noBudget) {
      buttons.push(
        <ButtonOutline
          key="no-budget-button"
          type="button"
          onClick={props.handleNoBudget}
          hasAnswer={hasAnswer && !isSingleChoice}
        >
          No Budget
        </ButtonOutline>
      );
    }

    // Optional question...
    if (props.optional && !hasAnswer) {
      buttons.push(
        <Button
          key="optional-button"
          type="submit"
          disabled={hasAnswer && isSingleChoice}
        >
          {props.optionalButtonText}
        </Button>
      );
    }

    // Next button, disable it if answer's invalid or
    if (hasAnswer && !isSingleChoice) {
      buttons.push(
        <Button key="next-button" type="submit" disabled={isInvalid}>
          Next
        </Button>
      );
    }

    return [...buttons];
  };

  return (
    <Wrapper>
      <Row>
        {props.percent > 0 && (
          <BackButton type="button" onClick={props.handlePrevious}>
            <ScreenReader>Exit Quiz</ScreenReader>
            <BackButtonImage>
              <Image src={backImage} alt="Back" />
            </BackButtonImage>
          </BackButton>
        )}

        <ButtonGroup>{outputButton()}</ButtonGroup>
      </Row>

      {props.showDisclaimer && (
        <Disclaimer long={props.disclaimer.length > 200}>
          {props.disclaimer}
        </Disclaimer>
      )}
    </Wrapper>
  );
};

export default Footer;
